import React, { Component } from "react";
import * as Loader from "../../common/common";
import * as xmlDownloadService from "../../services/xml-download/xml-download-service";
import { validateEntitlement } from "../../common/validate-entitlement";
import { FUNCTIONALITY, ENTITLEMENTS } from "../../common/const";
import Utility from "../../components/modal";

export default class XmlDownload extends Component {
  constructor(props) {
    super(props);
    this.download = this.download.bind(this);
  }

  state = {
    msg: "",
  };

  async download() {
    let msg = "No XML genereated to download. Please regenerate XML first.";
    let data = {
      clientId: this.props.obj.clientId,
      userType: this.props.obj.userType,
    };
    if (this.props.type === "infor") {
      Loader.showLoader();
      let { response, err } = await xmlDownloadService.downloadInforXml(data);
      Loader.hideLoader();
      if (err) {
      } else if (response.data && response.data.err) {
      } else {
        if (response.data.size <= 0) {
          this.setState(
            {
              msg: msg,
            },
            () => {
              setTimeout(() => this.setState({ msg: "" }), 1000);
            }
          );
        } else if (
          validateEntitlement(FUNCTIONALITY.generateXMLCSV, ENTITLEMENTS.create)
        ) {
          if (response.headers["content-disposition"]) {
            let fileName = response.headers["content-disposition"].split(
              "="
            )[1];
            fileName = fileName.substring(1, fileName.length - 1);
            this.downloadZip(response.data, "INFORXML_" + fileName);
          }
        }
      }
    } else if (this.props.type === "cfs-mag") {
      Loader.showLoader();
      let { response, err } = await xmlDownloadService.downloadCfsMagXml(data);
      Loader.hideLoader();
      if (err) {
      } else if (response.data && response.data.err) {
      } else {
        if (response.data.size <= 0) {
          this.setState(
            {
              msg: msg,
            },
            () => {
              setTimeout(() => this.setState({ msg: "" }), 1000);
            }
          );
        } else if (
          validateEntitlement(FUNCTIONALITY.generateXMLCSV, ENTITLEMENTS.create)
        ) {
          if (response.headers["content-disposition"]) {
            let fileName = response.headers["content-disposition"].split(
              "="
            )[1];
            fileName = fileName.substring(1, fileName.length - 1);
            this.downloadZip(response.data, "CFS-MAGXML_" + fileName);
          }
        }
      }
    } else if (this.props.type === "client") {
      Loader.showLoader();
      let { response, err } = await xmlDownloadService.downloadClientXml(data);
      Loader.hideLoader();
      if (err) {
      } else if (response.data && response.data.err) {
      } else {
        if (response.data.size <= 0) {
          this.setState(
            {
              msg: msg,
            },
            () => {
              setTimeout(() => this.setState({ msg: "" }), 1000);
            }
          );
        } else if (
          validateEntitlement(FUNCTIONALITY.generateXMLCSV, ENTITLEMENTS.create)
        ) {
          if (response.headers["content-disposition"]) {
            let fileName = response.headers["content-disposition"].split(
              "="
            )[1];
            fileName = fileName.substring(1, fileName.length - 1);
            this.downloadFile(response.data, fileName);
          }
        }
      }
    } else if (this.props.type === "contact") {
      Loader.showLoader();
      let { response, err } = await xmlDownloadService.downloadContactXml(data);
      Loader.hideLoader();
      if (err) {
      } else if (response.data && response.data.err) {
      } else {
        if (response.data.size <= 0) {
          this.setState(
            {
              msg: msg,
            },
            () => {
              setTimeout(() => this.setState({ msg: "" }), 1000);
            }
          );
        } else if (
          validateEntitlement(FUNCTIONALITY.generateXMLCSV, ENTITLEMENTS.create)
        ) {
          if (response.headers["content-disposition"]) {
            let fileName = response.headers["content-disposition"].split(
              "="
            )[1];
            fileName = fileName.substring(1, fileName.length - 1);
            this.downloadFile(response.data, fileName);
          }
        }
      }
    } else if (this.props.type === "bank") {
      Loader.showLoader();
      let { response, err } = await xmlDownloadService.downloadBankXml(data);
      Loader.hideLoader();
      if (err) {
      } else if (response.data && response.data.err) {
      } else {
        if (response.data.size <= 0) {
          this.setState(
            {
              msg: msg,
            },
            () => {
              setTimeout(() => this.setState({ msg: "" }), 1000);
            }
          );
        } else if (
          validateEntitlement(FUNCTIONALITY.generateXMLCSV, ENTITLEMENTS.create)
        ) {
          if (response.headers["content-disposition"]) {
            let fileName = response.headers["content-disposition"].split(
              "="
            )[1];
            fileName = fileName.substring(1, fileName.length - 1);
            this.downloadFile(response.data, fileName);
          }
        }
      }
    } else if (this.props.type === "address/be") {
      Loader.showLoader();
      let { response, err } = await xmlDownloadService.downloadAddressXml(data);
      Loader.hideLoader();
      if (err) {
      } else if (response.data && response.data.err) {
      } else {
        if (response.data.size <= 0) {
          this.setState(
            {
              msg: msg,
            },
            () => {
              setTimeout(() => this.setState({ msg: "" }), 1000);
            }
          );
        } else if (
          validateEntitlement(FUNCTIONALITY.generateXMLCSV, ENTITLEMENTS.create)
        ) {
          if (response.headers["content-disposition"]) {
            let fileName = response.headers["content-disposition"].split(
              "="
            )[1];
            fileName = fileName.substring(1, fileName.length - 1);
            this.downloadFile(response.data, fileName);
          }
        }
      }
    }
  }
  downloadZip(data, fileName) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  }
  downloadFile(data, fileName) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  }
  render() {
    return (
      <React.Fragment>
        {this.props.type === "infor" || this.props.type === "cfs-mag" ? (
          <span className="dropdown-item" onClick={this.download}>
            Download {this.props.displayTitle} XML
          </span>
        ) : (
          <button className="btn" onClick={this.download}>
            Download XML
          </button>
        )}
        {this.state.msg ? Utility.showAlert(this.state.msg) : ""}
      </React.Fragment>
    );
  }
}
